import React, { useEffect, useState } from 'react'
import Style from './SliderContainer.module.css'
import { getSliderDataApi } from '../../../Api/BarestServices'
import ProductHomeSlider from './ProductHomeSlider'
import SupplierHomeSlider from './SupplierHomeSlider'
const SliderContainer = () => {
    const[sliderDataState,setSliderDataState]=useState()
    const getSlidersDataHandler = () => {
        getSliderDataApi("home",(succ,res)=>{
            if(succ){  
                if(res.status===1){
                 const { message, status, ...payload } = res
                    setSliderDataState(payload)
                }
            }
            else{
                console.error(res);
            }
        })
    }
    useEffect(() => {
        getSlidersDataHandler()
    }, [])
    const mostSalesFoodData=sliderDataState?.sales_food?.filter(item=>parseInt(item.working_hours.open)!==0)
    const mostSalesSupermarketProductData=sliderDataState?.sales_supermarket?.filter(item=>parseInt(item.working_hours.open)!==0)
    const topMarketsData=sliderDataState?.sales_market?.filter(item=>parseInt(item.working_hours.open)!==0)
    const topRestaurantsData=sliderDataState?.sales_restaurant?.filter(item=>parseInt(item.working_hours.open)!==0)
    const mostSalesFoodDataExist=mostSalesFoodData?.length!==0
    const mostSalesSupermarketProductDataExist=mostSalesSupermarketProductData?.length!==0 
    const topMarketsDataExist=topMarketsData?.length!==0 
    const topRestaurantsDataExist=topRestaurantsData?.length!==0 

  return (
    <section className={Style.containerHolder}>
        {mostSalesSupermarketProductDataExist&&<ProductHomeSlider title={"محصولات پر طرفدارمون"} sliderData={mostSalesSupermarketProductData}/>}
        {mostSalesFoodDataExist&&<ProductHomeSlider title={"غذاهای پر طرفدارمون"} sliderData={mostSalesFoodData}/>}
        {topMarketsDataExist&&<SupplierHomeSlider title={"بهترین عملکرد فروشگاهی"} sliderData={topMarketsData} linkAddress={"Supermarkets"}/>}
        {topRestaurantsDataExist&&<SupplierHomeSlider title={"بهترین عملکرد رستوران و کافه"} sliderData={topRestaurantsData} linkAddress={"Restaurants"}/>}
    </section>
  )
}

export default SliderContainer